
<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :create-default-data="createDefaultData"
    max-width="900px"
    @closed="$emit('closed')"
  >
    <template #title-text="{ editable, form }">
      {{ getTitle(editable, form) }}
    </template>

    <template #default="{ editable, form, onSaveContinue }">
      <RoadmapDirectionsForm
        :form="form"
        :disabled="editable"
        @save-continue="onSaveContinue"
      />

      <RoadmapBaseEventsList
        v-if="form.id"
        :roadmap-id="roadmap_id"
        :direction-id="form.id"
        class="mt-2"
      />
    </template>
  </BModalForm>
</template>

<script>
import { RoadmapDirectionModel as Model } from '../Model'

import BModalForm from '@/components/modals/BModalForm.vue'
import RoadmapDirectionsForm, { createDefaultData } from './RoadmapDirectionsForm.vue'
import RoadmapBaseEventsList from '../BaseEvents/RoadmapBaseEventsList.vue'


export default {
  name: 'RoadmapDirectionsModal',
  components: {
    BModalForm,
    RoadmapDirectionsForm,
    RoadmapBaseEventsList,
  },
  inheritAttrs: false,
  props: {
    roadmap_id: {
      type: [Number, String],
      required: true,
    },
  },
  data: () => ({
    createDefaultData,
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    getTitle(editable, form) {
      if (editable) return Model.page_title.view(form)
      return form.id ? Model.page_title.edit : Model.page_title.create
    },
  },
}
</script>
